export async function getFAQ(view: string): Promise<QuestionAnswer[]> {
  const response = await fetch(`${__API_HOST__}/api/v1.1/faq?view=${view}`);
  const json = await response.json();
  return json.data;
}



// WEBPACK FOOTER //
// ./app/api/faq.ts